import React, { SVGProps } from 'react';

const SvgKakaoTalkIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke={props.color || 'currentColor'}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.6}
      d="M12 4.5c-4.556 0-8.25 2.874-8.25 6.42 0 2.293 1.545 4.306 3.867 5.457-.17.6-.616 2.18-.705 2.52-.11.42.156.415.328.303.135-.088 2.144-1.443 3.014-2.03.567.082 1.152.125 1.746.125 4.556 0 8.25-2.874 8.25-6.42S16.556 4.5 12 4.5Z"
    />
  </svg>
);
SvgKakaoTalkIcon.defaultProps = {
  width: '24',
  height: '24',
  color: 'currentColor',
};
export default SvgKakaoTalkIcon;
